export enum SendingStatus {
  Pending = 1,
  Sent,
  Delivered,
  Read,
  Error = 30,
}

export const sendingStatus = (): Record<SendingStatus, string> => ({
  [SendingStatus.Pending]: 'Pending',
  [SendingStatus.Sent]: 'Sent',
  [SendingStatus.Delivered]: 'Delivered',
  [SendingStatus.Read]: 'Read',
  [SendingStatus.Error]: 'Error',
})
